import React from 'react';
import SingleChildContent from '../Components/Children/SingleChildContent';
import LoginLayout from '../Layouts/LoginLayout';

export default function SingleChild() {
  return (
    <LoginLayout>
        <SingleChildContent />
    </LoginLayout>
  )
}
